module.exports = __webpack_public_path__ + "assets/img/member_nor.65ab6f36.png";